'use client';
import { ScrollToFormButton } from '@components/scrollToFormButton';
import { sendAnalyticsEvent } from '@lib/analytics/analytics';
import { FC } from 'react';

import { Button } from '../../button';
import { Card } from '../../card';
import { PageSection } from '../../pageSection';
import { Typography } from '../../typography';
import { DeploymentOption } from '../types';

interface Props {
  title: string;
  description?: string;
  options: DeploymentOption[];
}

export const DeploymentSection: FC<Props> = ({
  title,
  description,
  options,
}) => {
  return (
    <PageSection title={title} description={description}>
      <div className="flex gap-8 px-4 max-sm:flex-col-reverse max-sm:gap-6">
        {options.map((option) => (
          /** Применяем стили для высоты, чтобы карточки занимали всю высоту в общем ряду */
          <Card key={option.id} style={{ height: 'auto' }}>
            <div className="flex h-full flex-col gap-9 p-6 max-sm:gap-6 max-sm:p-5">
              <div className="flex flex-col gap-4">
                <div className="flex items-center justify-between gap-4">
                  <Typography variant="heading-m">{option.title}</Typography>
                  <div className="bg-surface-base-blur text-text-base-secondary shrink-0 rounded-[12px] px-4 py-2 text-[14px] leading-[16px] max-sm:px-3 max-sm:leading-[20px]">
                    {option.badge}
                  </div>
                </div>
                <ul className="flex flex-col gap-3">
                  {option.features.map((bullet) => (
                    <li key={bullet} className="flex items-baseline gap-2">
                      <span className="h-3 w-3 shrink-0 rounded-full bg-[#3BB643]" />
                      <span className="text-text-base-primary">{bullet}</span>
                    </li>
                  ))}
                </ul>
              </div>
              {option.button.href ? (
                <Button
                  variant="secondary"
                  href={option.button.href}
                  target={option.button.target}
                  onClick={
                    option.button.event
                      ? () => {
                          if (option.button.event) {
                            sendAnalyticsEvent(option.button.event);
                          }
                        }
                      : undefined
                  }
                  className="mt-auto w-full max-w-[241px] items-center justify-center pt-4 pr-6 pb-4 pl-6 max-md:max-w-full"
                >
                  {option.button.label}
                </Button>
              ) : (
                <ScrollToFormButton
                  className="mt-auto w-full max-w-[241px] items-center justify-center pt-4 pr-6 pb-4 pl-6 max-md:max-w-full"
                  variant={option.button.variant ?? 'secondary'}
                >
                  {option.button.label}
                </ScrollToFormButton>
              )}
            </div>
          </Card>
        ))}
      </div>
    </PageSection>
  );
};
